import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';
import { useSelector } from 'react-redux';

import { useInfrastructureMicrofrontend } from './useInfrastructureMicrofrontend';
import {
  InfrastructureError,
  InfrastructureLoader,
  InfrastructureWrapper,
} from '../../components/InfrastructureMicrofrontend';
import { getMapApiKey, getSuggestApiKey } from '../../selectors/common';
import { getDisplayName } from '../../selectors/newbuilding';

interface IInfrastureMicrofrontendContainerProps {
  headerLinks?: React.ReactNode;
}

export function InfrastructureMicrofrontendContainer({ headerLinks }: IInfrastureMicrofrontendContainerProps) {
  const newbuildingName = useSelector(getDisplayName);

  const { manifest, fetchManifest, status } = useInfrastructureMicrofrontend();

  const yandexApiKey = useSelector(getMapApiKey);
  const yandexSuggestApiKey = useSelector(getSuggestApiKey);

  const microfrontendParams = React.useMemo(
    () => ({
      yandexApiKey,
      yandexSuggestApiKey,
      profile: 'newbuilding',
    }),
    [yandexApiKey, yandexSuggestApiKey],
  );

  return (
    <InfrastructureWrapper headerLinks={headerLinks} title={`${newbuildingName} на карте`}>
      {status === 'loading' && <InfrastructureLoader />}
      {status === 'error' && <InfrastructureError retry={fetchManifest} />}
      {status === 'success' && manifest && (
        <Microfrontend
          name={manifest.microfrontendName}
          image={manifest.imageVersion}
          runtime={manifest.runtimeName}
          parameters={microfrontendParams}
        />
      )}
    </InfrastructureWrapper>
  );
}
